module.exports = __webpack_public_path__ + "img/img-a38205.png";